module.exports = __webpack_public_path__ + "img/flight_status_ellipse.591b5a4.png";